export default __webpack_public_path__ + "static/media/serenityyetmis2.d219fba9.jpg";